(function() {
  'use strict';

  angular
    .module('admin.explore.customfeature.service', [])
    .factory('ExploreCustomFeatureService', ExploreCustomFeatureService);

  /** @ngInject */
  function ExploreCustomFeatureService($http, $q, API) {

    function list(t, start, limit){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/banner_lists?t=' + t + '&start=' + start + '&limit=' + limit + '&sort=id-desc')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listAll(){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/banner_lists')
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }

    function listBalbas(id, start, limit){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/banner_lists/' + id + '/balbas?start=' + start + '&limit=' + limit + '&sort=n-asc')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function get(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/banner_lists/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function create(model){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/banner_lists', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function createBalbas(id, model){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/banner_lists/' + id + '/balbas', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function update(id, model){
      var defered = $q.defer();

      $http.put(API.API_URL + 'admin/banner_lists/' + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function updateBalbas(parentId, id, model){
      var defered = $q.defer();

      $http.put(API.API_URL + 'admin/banner_lists/' + parentId + '/balbas/' + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function remove(id){
      var defered = $q.defer();

      $http.delete(API.API_URL + 'admin/banner_lists/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeBalbas(parentId, id){
      var defered = $q.defer();

      $http.delete(API.API_URL + 'admin/banner_lists/' + parentId + '/balbas/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return{
       list: list,
       listAll: listAll,
       listBalbas: listBalbas,
       get: get,
       create: create,
       createBalbas: createBalbas,
       updateBalbas: updateBalbas,
       update: update,
       remove: remove,
       removeBalbas: removeBalbas,
    };

  }

})();
